import type MathsFluencySprintsTeacherStudentResultsOverviewRoute from 'teacher-ui-client/reporting/ui-scope/maths/fluency-sprints/teacher/student-results-overview/route'
import type MathsFluencySprintsTeacherStudentResultsOverviewController from 'teacher-ui-client/reporting/ui-scope/maths/fluency-sprints/teacher/student-results-overview/controller'
import {
  FluencySprintsStudentResultsOverview,
  type StudentResultsOverviewStudentItem,
} from 'teacher-ui-client/components/tables/fluency-sprints/student-results-overview'
import RouteTemplate from 'ember-route-template'
import Component from '@glimmer/component'
import { service } from '@ember/service'
import { isPresent } from '@ember/utils'
import { Precinct } from 'teacher-ui-client/utils/precincts'
import type LessonInfoService from 'teacher-ui-client/services/lesson-info'

interface Signature {
  Args: {
    model: ModelFor<MathsFluencySprintsTeacherStudentResultsOverviewRoute>
    controller: MathsFluencySprintsTeacherStudentResultsOverviewController
  }
}

export class MathsFluencySprintsTeacherStudentResultsOverviewPage extends Component<Signature> {
  @service lessonInfo!: LessonInfoService

  get students(): StudentResultsOverviewStudentItem[] {
    const { mentalMinuteOverview, scopedStudents } = this.args.model
    if (!mentalMinuteOverview) return []

    return mentalMinuteOverview?.students
      .map((studentData) => {
        const studentRecord = scopedStudents.find((student) => student.id === String(studentData.student_id))
        if (!studentRecord) return null

        const lessonId = Number(studentData.highest_skill_mastered) || 0
        const lessonName = lessonId
          ? (this.lessonInfo.lessonsFor(Precinct.MS_MENTAL_MINUTE).find((lesson) => lesson.lesson_number === lessonId)
              ?.name ?? '')
          : ''
        const lessonLabel = lessonId ? `${lessonId}: ${lessonName}` : ''

        return {
          ...studentData,
          first_name: studentRecord.firstName,
          last_name: studentRecord.lastName,
          external_id: studentRecord.externalId,
          highest_lesson_passed: { id: lessonId, name: lessonName, label: lessonLabel },
        }
      })
      .filter(isPresent)
  }

  <template>
    <FluencySprintsStudentResultsOverview
      @students={{this.students}}
      @aggregate={{@model.mentalMinuteOverview.aggregate}}
      @studentRouteName="reporting.ui-scope.maths.fluency-sprints.student.table"
      @onSortClick={{@controller.updateSorts}}
      @sortingConfig={{@controller.sortingConfig}}
      @paginationConfig={{@controller.paginationConfig}}
      @exportable={{true}}
    />
  </template>
}

export default RouteTemplate(MathsFluencySprintsTeacherStudentResultsOverviewPage)
